














import { Component, Vue } from 'vue-property-decorator';
import LabelList from './labelList.vue';

@Component({
  components: {
    LabelList,
  },
})
export default class TwoLevelDrawer extends Vue {
  public visible: boolean = false;
  public currentComponent: string = '';
  private onClose() {
    this.visible = !this.visible;
  }
}
